import { useMemo, useState } from "react";
import EventCard from "@/components/feature/EventCard";
import { eventCategories, eventStatuses, events } from "@/mocks/events";

export default function EventsExplorer() {
  const [category, setCategory] = useState("全部");
  const [status, setStatus] = useState("全部状态");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    const kw = keyword.trim();
    return events.filter((item) => {
      const matchCategory = category === "全部" || item.category === category;
      const matchStatus = status === "全部状态" || item.status === status;
      const matchKeyword =
        kw === "" ||
        item.title.includes(kw) ||
        item.summary.includes(kw) ||
        item.platform.includes(kw) ||
        item.room.includes(kw) ||
        item.tags.some((tag) => tag.includes(kw));
      return matchCategory && matchStatus && matchKeyword;
    });
  }, [category, status, keyword]);

  const resetFilters = () => {
    setCategory("全部");
    setStatus("全部状态");
    setKeyword("");
  };

  return (
    <div>
      <div className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5">
        <div className="flex flex-wrap gap-2">
          {eventCategories.map((item) => {
            const active = category === item;
            return (
              <button
                key={item}
                type="button"
                onClick={() => setCategory(item)}
                aria-pressed={active}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-foreground-950"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>

        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center w-4 h-4 text-foreground-400">
              <i className="ri-search-line text-base" aria-hidden="true"></i>
            </span>
            <input
              type="search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索事件标题、平台、直播间或标签"
              className="w-full pl-9 pr-3.5 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30 transition-colors"
            />
          </div>
          <select
            value={status}
            onChange={(event) => setStatus(event.target.value)}
            className="sm:w-44 px-3.5 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30 transition-colors"
          >
            {eventStatuses.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="mt-4 flex items-center justify-between gap-3 text-sm text-foreground-600">
          <span>
            共找到 <strong className="font-heading text-foreground-950">{filtered.length}</strong> 起争议事件
          </span>
          <button
            type="button"
            onClick={resetFilters}
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            重置筛选
          </button>
        </div>
      </div>

      {filtered.length > 0 ? (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filtered.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      ) : (
        <div className="mt-8 bg-background-100 border border-background-200 rounded-lg py-16 text-center">
          <span className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-search-eye-line text-2xl" aria-hidden="true"></i>
          </span>
          <p className="mt-4 text-base font-medium text-foreground-950">没有匹配的争议事件</p>
          <p className="mt-2 text-sm text-foreground-600">试试更换分类或减少关键词，也可以直接提交一条新的举报线索。</p>
          <button
            type="button"
            onClick={resetFilters}
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            重置筛选条件
          </button>
        </div>
      )}
    </div>
  );
}